import { render, staticRenderFns } from "./ArtworkDialog.vue?vue&type=template&id=31a57522&scoped=true"
import script from "./ArtworkDialog.vue?vue&type=script&lang=js"
export * from "./ArtworkDialog.vue?vue&type=script&lang=js"
import style0 from "./ArtworkDialog.vue?vue&type=style&index=0&id=31a57522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a57522",
  null
  
)

export default component.exports